/* import __COLOCATED_TEMPLATE__ from './billing-period-toggle.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { BILLING_PERIODS } from 'embercom/lib/billing';
import { inject as service } from '@ember/service';
import type QuoteService from 'embercom/services/quote-service';

interface Args {
  loading: boolean;
  billingPeriod: BILLING_PERIODS;
  updateBillingPeriod: (value: BILLING_PERIODS) => void;
  isComparisonModal?: boolean;
  monthlyTotal: number;
  monthlyDiscountedTotal: number;
  perSeatCopilotAddonPrice: number;
  discountedCopilotSeatPrice: number;
  selectedNumberOfCopilotAdmins: number;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class BillingPeriodToggle extends Component<Signature> {
  @tracked billingPeriod = this.args.billingPeriod;
  @service declare quoteService: QuoteService;
  monthsInYear = 12;

  get monthlyBillingPeriodValue() {
    return BILLING_PERIODS.Monthly;
  }

  get annualBillingPeriodValue() {
    return BILLING_PERIODS.Annual;
  }

  get isAnnual() {
    return this.billingPeriod === this.annualBillingPeriodValue;
  }

  get yearlySavings() {
    if (this.isAnnual) {
      return this.quoteService.formatPrice(this.annualListPrice - this.annualDiscountedPrice);
    } else {
      return this.quoteService.formatPrice(
        this.annualListPrice -
          this.annualDiscountedPrice +
          (this.annualCopilotPrice - this.annualDiscountedCopilotPrice) *
            this.args.selectedNumberOfCopilotAdmins,
      );
    }
  }

  get annualCopilotPrice() {
    return this.args.perSeatCopilotAddonPrice * this.monthsInYear;
  }

  get annualDiscountedCopilotPrice() {
    return this.args.discountedCopilotSeatPrice * this.monthsInYear;
  }

  get annualListPrice() {
    return this.args.monthlyTotal * this.monthsInYear;
  }

  get annualDiscountedPrice() {
    return this.args.monthlyDiscountedTotal * this.monthsInYear;
  }

  @action
  toggleBillingPeriod(period: number) {
    let newPeriod = period === 1 ? this.monthlyBillingPeriodValue : this.annualBillingPeriodValue;

    this.billingPeriod = newPeriod;
    this.args.updateBillingPeriod(newPeriod);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AnnualPlans::BillingPeriodToggle': typeof BillingPeriodToggle;
  }
}
